import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ContactModal } from '../components/ui/ContactModal';
import { SpecialistCoordinationModal } from '../components/ui/SpecialistCoordinationModal';
import { User } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function SpecialistsPage() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isSpecialistFormOpen, setIsSpecialistFormOpen] = useState(false);
  const {
    t
  } = useLanguage();
  const specialists = [{
    name: 'Dr. Roberto Martinez',
    specialty: t.specialties.items.general.name,
    creds: 'MD, FACS'
  }, {
    name: 'Dr. Elena Rodriguez',
    specialty: t.specialties.items.laparoscopic.name,
    creds: 'MD, PhD'
  }, {
    name: 'Dr. Carlos Mendez',
    specialty: t.specialties.items.orthopedic.name,
    creds: 'MD'
  }, {
    name: 'Dr. Sofia Silva',
    specialty: t.specialties.items.ent.name,
    creds: 'MD'
  }, {
    name: 'Dr. Javier Lopez',
    specialty: t.specialties.items.urological.name,
    creds: 'MD'
  }, {
    name: 'Dr. Ana Castillo',
    specialty: t.specialties.items.oncological.name,
    creds: 'MD'
  }];
  return <div className="pt-20" data-id="element-660">
      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} defaultSubject="Specialist Inquiry" data-id="element-661" />
      <SpecialistCoordinationModal isOpen={isSpecialistFormOpen} onClose={() => setIsSpecialistFormOpen(false)} data-id="element-662" />

      {/* Hero */}
      <div className="bg-caces-blue text-white py-20" data-id="element-663">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-664">
          <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4" data-id="element-665">
            {t.specialists.hero.title}
          </h1>
          <p className="text-xl text-caces-light max-w-2xl mx-auto" data-id="element-666">
            {t.specialists.hero.subtitle}
          </p>
        </div>
      </div>

      {/* Intro */}
      <section className="py-12 bg-white border-b border-gray-100" data-id="element-667">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-668">
          <p className="text-lg text-gray-600" data-id="element-669">{t.specialists.intro}</p>
        </div>
      </section>

      {/* Specialists Grid */}
      <section className="py-16 bg-gray-50" data-id="element-670">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-671">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-672">
            {specialists.map((doc, index) => <Card key={index} className="p-6 text-center hover:shadow-md transition-shadow" data-id="element-673">
                <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center text-gray-400" data-id="element-674">
                  <User size={48} data-id="element-675" />
                </div>
                <h3 className="font-serif text-xl font-bold text-caces-navy" data-id="element-676">
                  {doc.name}
                </h3>
                <p className="text-caces-accent font-medium mb-1" data-id="element-677">
                  {doc.specialty}
                </p>
                <p className="text-gray-500 text-sm mb-6" data-id="element-678">{doc.creds}</p>
                <Button variant="outline" size="sm" fullWidth onClick={() => setIsContactModalOpen(true)} data-id="element-679">
                  {t.specialists.btn}
                </Button>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-12 bg-white" data-id="element-680">
        <div className="max-w-5xl mx-auto px-4" data-id="element-681">
          <div className="bg-yellow-50 border border-yellow-100 p-6 rounded-lg flex gap-4 items-start" data-id="element-682">
            <div className="flex-shrink-0 mt-1" data-id="element-683">
              <User className="text-yellow-600" size={20} data-id="element-684" />
            </div>
            <div data-id="element-685">
              <h4 className="font-bold text-yellow-800 mb-1" data-id="element-686">
                {t.specialists.disclaimer.title}
              </h4>
              <p className="text-yellow-700 text-sm leading-relaxed" data-id="element-687">
                {t.specialists.disclaimer.text}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* For Specialists — opens the dedicated specialist coordination form */}
      <section className="py-16 bg-caces-navy text-white" data-id="element-688">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-689">
          <h2 className="font-serif text-3xl font-bold mb-4" data-id="element-690">
            {t.specialists.join.title}
          </h2>
          <p className="text-caces-light mb-8" data-id="element-691">{t.specialists.join.desc}</p>
          <Button variant="white" onClick={() => setIsSpecialistFormOpen(true)} data-id="element-692">
            {t.specialists.join.btn}
          </Button>
        </div>
      </section>
    </div>;
}